export default "<h2 >Erreur suvenue</h2>\r\n    <p i18n>Veuillez contacter votre administrateur</p>\r\n\r\n";